export const levelRouteName = {
  index: "levels.index",
};

export const levelRoute = [
  {
    path: "/levels",
    name: levelRouteName.index,
    component: () => import("../pages/DataTablePage.vue"),
    meta: {
      requiresAuth: true,
      layout: "adminSidebar",
      menu: "level",
      breadcrumbs: () => {
        return [{ title: "Level" }];
      },
    },
  },
];
